// extracted by mini-css-extract-plugin
module.exports = {"body":"TextShowShop_body__3CpJ4"};